// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 483 ? "Shell" : chunkId) + "." + {"131":"1fea736c","483":"28dc3e76"}[chunkId] + ".chunk.css";
};